import { useEffect, useState } from 'react';
import { supabase } from '../lib/supabase';

export type PartnerCategory = 'figurinhas' | 'albuns' | 'acessorios';

export interface PartnerProduct {
  id: string;
  slug: string;
  category: PartnerCategory;
  title: string;
  subtitle: string | null;
  badge: string | null;
  affiliate_url: string;
  image_url: string | null;
  icon: string | null;
  position: number;
  active: boolean;
}

export interface CategoryGroup {
  category: PartnerCategory;
  products: PartnerProduct[];
}

const CATEGORY_ORDER: PartnerCategory[] = ['figurinhas', 'albuns', 'acessorios'];

export function usePartnerProducts() {
  const [products, setProducts] = useState<PartnerProduct[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;
    void (async () => {
      const { data, error: err } = await supabase
        .from('partner_products')
        .select('*')
        .eq('active', true)
        .order('position', { ascending: true });
      if (cancelled) return;
      if (err) {
        setError(err.message);
        setProducts([]);
      } else {
        setProducts((data ?? []) as PartnerProduct[]);
      }
      setLoading(false);
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  const grouped: CategoryGroup[] = CATEGORY_ORDER.map((cat) => ({
    category: cat,
    products: products.filter((p) => p.category === cat),
  })).filter((g) => g.products.length > 0);

  return { products, grouped, loading, error };
}
